import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import ParticipantTracks from 'components/ParticipantTracks/ParticipantTracks'
import Tile from 'components/Tiles'
import { trackKinds, trackPriorities } from 'constants/twilio'
import { isObjectEmpty } from 'helpers/object'
import { isVideoTrackPublicationSubscribed } from 'helpers/twilio'
import useDominantSpeaker from 'hooks/useDominantSpeaker/useDominantSpeaker'
import useIsTrackSwitchedOff from 'hooks/useIsTrackSwitchedOff/useIsTrackSwitchedOff'
import usePublications from 'hooks/usePublications/usePublications'
import useTrack from 'hooks/useTrack/useTrack'
import { _studentsCount } from 'store/selectors/Room'

export default function Participant({
    identity,
    participant,
    enableScreenShare,
    isTeacher,
    isTeacherIdentity,
    lastIndex,
    isLocal,
}) {
    const publications = usePublications(participant)
    const audioPublication = publications.find(p => p.kind === trackKinds.audio)
    const audioTrack = useTrack(audioPublication)
    const [isLoading, setLoading] = useState(true)
    const studentsCount = useSelector(_studentsCount)
    const videoPublication = publications.find(
        p => p.kind === 'video' && p.trackName !== 'screen'
    )

    const videoTrack = useTrack(videoPublication)
    const trackSwitchedOff = useIsTrackSwitchedOff(videoTrack)
    const isVideoEnabled =
        !isObjectEmpty(videoPublication) &&
        isVideoTrackPublicationSubscribed(videoPublication) &&
        !trackSwitchedOff

    const dominantSpeaker = useDominantSpeaker()

    useEffect(() => {
        if (!publications || !isLoading) return
        setLoading(false)
    }, [publications, isLoading])

    const isActiveSpeaker =
        dominantSpeaker && dominantSpeaker.identity.startsWith(identity?.uuid)

    const videoPriority = isTeacher
        ? trackPriorities.STANDARD
        : trackPriorities.LOW

    return isLoading || identity?.isGhost ? null : (
        <Tile
            identity={identity}
            isTeacher={isTeacher}
            audioTrack={audioTrack}
            isLocal={isLocal}
            isVideoEnabled={isVideoEnabled}
            studentsCount={studentsCount}
            isActiveSpeaker={isActiveSpeaker}
        >
            <ParticipantTracks
                isLocal={isLocal}
                publications={publications}
                participant={participant}
                enableScreenShare={enableScreenShare}
                isTeacher={isTeacher}
                isTeacherIdentity={isTeacherIdentity}
                lastIndex={lastIndex}
                videoPriority={videoPriority}
            />
        </Tile>
    )
}
